// = require ui-select

// TODO: This is a hack to compensate for a feature not yet available in
// ui-select. This can be removed at a later point when 'limit' is supported.
angular.module('directives.uiSelect', ['ui.select'])
  .config(['uiSelectConfig', function(uiSelectConfig) {
    uiSelectConfig.theme = 'select2';
    uiSelectConfig.refreshDelay = 300;
  }])
  .directive('uiSelect', function () {
    return {
      restrict: 'EA',
      require: 'uiSelect',
      link: function($scope, $element, $attributes, ctrl) {
        $scope.$select.limit = (angular.isDefined($attributes.limit)) ? parseInt($attributes.limit, 10) : undefined;
        ctrl.resetSearchInput = true;
        var superSelect = ctrl.select;
        ctrl.select = function() {
          if(!(ctrl.multiple && ctrl.limit !== undefined && ctrl.selected.length >= ctrl.limit)) {
            superSelect.apply(ctrl, arguments);
          }
        };

        $scope.lastAjaxQuery = '';
        $scope.lastAjaxQueryResponse = [];

        $scope.reloadAjaxQuery = function(queryPromise, ajaxQuery, flatten,
          params, queryParameterName) {
          if ($scope.lastAjaxQuery !== ajaxQuery && ajaxQuery.length > 0) {
            $scope.lastAjaxQuery = ajaxQuery;
            params = params || {};
            if (queryParameterName) {
              params[queryParameterName] = ajaxQuery;
            } else {
              params.q = ajaxQuery;
            }
            queryPromise.get(params).$promise.then(function (response) {
              $scope.lastAjaxQueryResponse = _.map(response, function(val) {
                if (flatten) {
                  return val.name;
                }
                return val;
              });
            });
          }
        };
      }
    };
  })

  // Use 'ui-select-required' to require a multi ui-select instead of 'require'
  .directive('uiSelectRequired', function() {
    return {
      require: 'ngModel',
      link: function(scope, elm, attrs, ctrl) {
        ctrl.$validators.uiSelectRequired = function(modelValue, viewValue) {
          return modelValue && modelValue.length;
        };
      }
    };
  });
